import { LocalStorageService } from './../../../../../core/services/local-storage.service';
import { ClientfinalCraService } from './../../../../../core/services/clientfinal-cra/clientfinal-cra.service';
import { Component, TemplateRef } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {
  addedCra,
  confirmDelete,
  deletedCra,
  existedCra,
  failedDelete,
  serverError,
  updatedCra,
} from './../../../../../core/models/messages';
import { ITimesheet } from './../../../../../core/models/questionTestEsn';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-type-activity-timesheet',
  templateUrl: './type-activity-timesheet.component.html',
  styleUrls: ['./type-activity-timesheet.component.css'],
})
export class TypeActivityTimesheetComponent {
  /* numbers */
  itemsPerPage: number = 5;
  currentPage: number = 1;
  totalItems!: number;
  startIndex: number = 0;
  endIndex: number = 5;
  idCra!: number;
  clickCount: number = 0;
  /* string */
  mode: string = 'addActivity';
  searchValue: string = '';
  searchElement: string = '';
  /* array */
  listTimesheet: ITimesheet[] = [];
  familyTypes = [
    { id: '1', name: 'Production ' },
    { id: '2', name: 'Absence' },
    { id: '3', name: 'Interne' },
  ];
  isLoadSpinner: boolean = true;

  /* formGroup */
  createLineCra: FormGroup = this.createLineCraForm();
  /* modal */
  modalRef?: BsModalRef;
  company_id: any;
  pagination : boolean =false;

  /* subscriprion */
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private activitytimesheet: ClientfinalCraService,
    private formBuilder: FormBuilder,
    private modalService: BsModalService,
    private localStorageService: LocalStorageService
  ) {}
  /* init */
  ngOnInit() {
    this.company_id = this.localStorageService.getData('clientConnected');
    console.log('id company', this.company_id);
    this.getListAccounts();
  }
  /* get indexes for pagination */
  getItems(event?: any) {
    if (
      (event && event.startIndex != this.startIndex) ||
      this.endIndex != event.endIndex ||
      this.itemsPerPage != event.itemsPerPage ||
      this.currentPage != event.currentPage
    ) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
      if (this.searchElement != '') this.applyFilter();
      else  if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){       
         this.pagination = true
      this.getListAccounts();
      }
    }
  }
  getListAccounts() {
    let data = {
      company_id: this.company_id,
      per_page: this.itemsPerPage,
      page: this.currentPage,
    };
    this.spinner.show();
    this.activitytimesheet
      .getListtypeactivitetimesheet(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.isLoadSpinner = false;

          console.log('ressssss', res);
          if (res.status == 200) {
            this.spinner.hide();
            (this.listTimesheet = res.data.items.data),
              (this.totalItems = res.data.items.total);
          }
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error(serverError);
        },
      });
  }
  /* create add subCategory form */
  createLineCraForm(data?: ITimesheet) {
    return this.formBuilder.group({
      name: [
        data ? data.name : '',
        [Validators.required],
        this.maxLengthValidator(50),
      ],
      family: [
        data
          ? data.family == 'Absence'
            ? '2'
            : data.family == 'Interne'
            ? '3'
            : '1'
          : null,
        [Validators.required],
      ],
      company_id: [this.localStorageService.getData('clientConnected')],
    });
  }
  maxLengthValidator(maxLength: number): ValidatorFn {
    return (control: AbstractControl): Promise<ValidationErrors | null> => {
      return new Promise((resolve) => {
        const value = control.value as string;
        console.log('Valeur du champ :', value);
        if (value && value.length > maxLength) {
          resolve({ maxLengthExceeded: true });
        } else {
          resolve(null);
        }
      });
    };
  }

  submitData() {
    if (this.mode == 'addActivity') {
      this.addAccount();
    } else {
      this.updateAccount();
    }
  }
  addAccount() {
    this.spinner.show();
    this.createLineCra.get('company_id')?.setValue(this.company_id);
    console.log('createLineCra', this.createLineCra.value);
    this.activitytimesheet
      .addTimesheet(this.createLineCra.value)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if (res.status == 200) {
            this.toastr.success(addedCra);
            this.getListAccounts();
            this.closeModal();
            this.spinner.hide();
            this.createLineCra.reset();
          }
        },
        error: (err) => {
          this.spinner.hide();
          if (err.error) {
            if (err.error.message && err.error.message['name'])
              this.toastr.info(existedCra);
            else this.toastr.error(serverError);
          }
        },
      });
  }
  updateAccount() {
    this.spinner.show();
    this.activitytimesheet
      .updatetypeactivitetimesheet(this.idCra, this.createLineCra.value)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if (res.status == 200) {
            this.toastr.success(updatedCra);
            this.getListAccounts();
            this.closeModal();
            this.spinner.hide();
            this.createLineCra.reset();
          }
        },
        error: (err) => {
          this.spinner.hide();
          if (err.error) {
            if (err.error.message && err.error.message['name'])
              this.toastr.info(existedCra);
            else this.toastr.error(serverError);
          }
        },
      });
  }
  /* open delete alert */
  openDeleteAlert(cra: ITimesheet) {
    Swal.fire({
      title: `${confirmDelete} cette activité ?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Supprimer',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteAccount(cra.id);
      } else if (result.isDismissed) {
        Swal.fire(failedDelete, '', 'error');
      }
    });
  }
  /* delete cra */
  deleteAccount(id: number) {
    this.spinner.show();
    this.activitytimesheet
      .deletetypeactivitetimesheet(id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if (res.status == 200) {
            this.spinner.hide();
            this.getListAccounts();
            this.toastr.success(deletedCra);
          }
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error(serverError);
        },
      });
  }
  /* filter data on key up input */
  applyFilter() {
    if (this.searchElement != '' || this.clickCount) {
      this.clickCount++;
      if (this.clickCount == 1) this.currentPage = 1;
      let data = {
        searchName: this.searchElement.trim().toLowerCase(),
        page: this.currentPage,
        per_page: this.itemsPerPage,
      };
      this.spinner.show();
      this.activitytimesheet
        .searchtypeactivitetimesheet(data, this.company_id)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            if (this.currentPage > 1) {
              this.currentPage = 1;
              this.applyFilter();
            } else {
              this.listTimesheet = res.data.items.data.slice(0, this.endIndex);
              this.totalItems = res.data.items.total;
            }
            this.spinner.hide();
          },
          error: () => {
            this.spinner.hide();
            this.toastr.error(serverError);
          },
        });
    }
  }
  openModal(template: TemplateRef<any>, mode: string, cra?: ITimesheet) {
    this.mode = mode;
    if (cra) {
      this.idCra = cra.id;
      this.createLineCra = this.createLineCraForm(cra);
    }
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
  }
  closeModal() {
    this.modalRef!.hide();
    this.createLineCra.reset();
  }
  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
